module.exports = __webpack_public_path__ + "static/media/salon-kariyer-tam.5d35a707.svg";